import React from 'react';
import BaseAlert, { AlertId, AlertTypes, BaseAlertProps } from './BaseAlert';

/** See Base Alert for props */
const DangerAlert = ({
    includeCloseButton,
    animated,
    includeImage,
    strong,
    customImage,
    message
}: BaseAlertProps) => {
    return (
        <BaseAlert
            alertType={AlertTypes[AlertId.Danger]}
            includeImage={includeImage}
            customImage={customImage}
            includeCloseButton={includeCloseButton}
            animated={animated}
            strong={strong}
            message={message}
        />
    );
};

export default DangerAlert;
